import { render, staticRenderFns } from "./stallholderTags.vue?vue&type=template&id=2baa8e74&scoped=true"
import script from "./stallholderTags.vue?vue&type=script&lang=js"
export * from "./stallholderTags.vue?vue&type=script&lang=js"
import style0 from "./stallholderTags.vue?vue&type=style&index=0&id=2baa8e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baa8e74",
  null
  
)

export default component.exports